const stripTrailingSlash = (value) => value.replace(/\/+$/, '');

const DEFAULT_API_URL = 'http://localhost:3001/api';

const rawApiUrl = stripTrailingSlash(
  process.env.REACT_APP_API_URL || DEFAULT_API_URL
);

const apiBaseFromEnv = process.env.REACT_APP_API_BASE_URL
  ? stripTrailingSlash(process.env.REACT_APP_API_BASE_URL)
  : stripTrailingSlash(rawApiUrl.replace(/\/api$/i, ''));

const uploadsBaseFromEnv = process.env.REACT_APP_UPLOADS_BASE_URL
  ? stripTrailingSlash(process.env.REACT_APP_UPLOADS_BASE_URL)
  : stripTrailingSlash(`${apiBaseFromEnv}/uploads`);

const isAbsoluteUrl = (value = '') => /^https?:\/\//i.test(value);

const resolveBackendPath = (path = '') => {
  if (!path) return '';
  if (isAbsoluteUrl(path)) return path;
  const normalizedPath = path.replace(/^\/+/, '');
  return `${apiBaseFromEnv}/${normalizedPath}`;
};

const resolveUploadsPath = (path = '') => {
  if (!path) return '';
  if (isAbsoluteUrl(path)) return path;
  const normalizedPath = path
    .replace(/^\/+/, '')
    .replace(/^uploads\/+/, '');
  return `${uploadsBaseFromEnv}/${normalizedPath}`;
};

// Prefer local backend proxy for thumbnails (avoids Google Drive thumbnail rate limits).
const getLocalThumbnailUrl = (photo) => {
  const token = photo?.photo_token ?? photo?.photo_id;
  return token ? `${rawApiUrl}/photos/${token}/thumbnail` : null;
};
const getLocalImageUrl = (photo) => {
  const token = photo?.photo_token ?? photo?.photo_id;
  return token ? `${rawApiUrl}/photos/${token}` : null;
};
const getLocalCompressedUrl = (photo) => {
  const token = photo?.photo_token ?? photo?.photo_id;
  return token ? `${rawApiUrl}/photos/${token}/compressed` : null;
};

// Google Drive CDN URLs (fallback only; prefer local proxy to avoid rate limits).
const DRIVE_THUMBNAIL_SZ = 'w1200';
const getDriveThumbnailUrl = (driveFileId) =>
  driveFileId ? `https://drive.google.com/thumbnail?id=${driveFileId}&sz=${DRIVE_THUMBNAIL_SZ}` : null;
const getDriveImageUrl = (driveFileId) =>
  driveFileId ? `https://drive.google.com/thumbnail?id=${driveFileId}&sz=${DRIVE_THUMBNAIL_SZ}` : null;
const toDriveThumbnailUrl = (urlOrId) => {
  if (!urlOrId) return null;
  if (typeof urlOrId === 'string' && urlOrId.startsWith('http')) {
    const ucMatch = urlOrId.match(/drive\.google\.com\/uc\?id=([^&\s]+)/i);
    if (ucMatch) return `https://drive.google.com/thumbnail?id=${ucMatch[1]}&sz=${DRIVE_THUMBNAIL_SZ}`;
    const thumbMatch = urlOrId.match(/drive\.google\.com\/thumbnail\?id=([^&\s]+)/i);
    if (thumbMatch) return urlOrId;
  }
  return getDriveThumbnailUrl(urlOrId);
};

export const API_URL = rawApiUrl;
export const API_BASE_URL = apiBaseFromEnv;
export const UPLOADS_BASE_URL = uploadsBaseFromEnv;
export {
  resolveBackendPath,
  resolveUploadsPath,
  getLocalThumbnailUrl,
  getLocalImageUrl,
  getLocalCompressedUrl,
  getDriveThumbnailUrl,
  getDriveImageUrl,
  toDriveThumbnailUrl,
};
export default {
  API_URL,
  API_BASE_URL,
  UPLOADS_BASE_URL,
  resolveBackendPath,
  resolveUploadsPath,
  getLocalThumbnailUrl,
  getLocalImageUrl,
  getLocalCompressedUrl,
  getDriveThumbnailUrl,
  getDriveImageUrl,
  toDriveThumbnailUrl,
};

